import { createContext } from 'react';

const RecipeFilterContext = createContext();

export default RecipeFilterContext;
